import { useMemo, useSyncExternalStore } from 'react';

import {
  OrgInfoCache,
  parseOrgInfo,
  readOrgInfoRaw,
  subscribeOrgInfo
} from '../helpers/orgInfoCache';

const getServerSnapshot = (): string | null => null;

/**
 * The cached organisation info for the signed in organisation admin, kept in
 * step with localStorage. `useSyncExternalStore` (React 18) does the
 * subscription so the component re-renders when the session reducer or the
 * Swiftaid panel rewrites the cache, or another tab does. The snapshot is the
 * raw string and is parsed once per change.
 */
export const useOrgInfo = (): OrgInfoCache | null => {
  const raw = useSyncExternalStore(
    subscribeOrgInfo,
    readOrgInfoRaw,
    getServerSnapshot
  );
  return useMemo(() => parseOrgInfo(raw), [raw]);
};
